import { render } from "./HorariosBackOfficeSection.vue?vue&type=template&id=f0d4ed72&scoped=true"
import script from "./HorariosBackOfficeSection.vue?vue&type=script&lang=js"
export * from "./HorariosBackOfficeSection.vue?vue&type=script&lang=js"

import "./HorariosBackOfficeSection.vue?vue&type=style&index=0&id=f0d4ed72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0d4ed72"]])

export default __exports__